export enum SESSION_STATE {
  ACTIVE = 'A',
  INACTIVE = 'I',
}
